import React, { Component } from "react";
import { Col, Modal, Row, Tabs, Tag, Tooltip } from "antd";
import currencyFormat from "../../helper/currencyFormat";
import moment from "moment";

class ModalDetailOrder extends Component<any, any> {
  private readonly initState!: any;

  constructor(props: any) {
    super(props);

    this.initState = {
      dataOrder: this.props.dataOrder ? this.props.dataOrder : {},
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  render() {
    const dataOrder = this.props.dataOrder;

    return (
      <Modal title="Detail Order" visible={this.props.visible} onCancel={this.props.onClose} footer={null} width={900}>
        {dataOrder && (
          <Tabs defaultActiveKey="1" style={{ margin: 0, padding: 0 }}>
            <Tabs.TabPane tab="Data Konsumen" key="1">
              <Row>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Tipe Konsumen</Col>
                    <Col span={16}>:&nbsp;{dataOrder.customer_type}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No Identitas</Col>
                    <Col span={16}>:&nbsp;{dataOrder.customer_identity_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama Konsumen</Col>
                    <Col span={16}>:&nbsp;{dataOrder.customer_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama di Dokumen</Col>
                    <Col span={16}>:&nbsp;{dataOrder.customer_doc_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No telepon</Col>
                    <Col span={16}>:&nbsp;{dataOrder.customer_phone}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={8}>Alamat</Col>
                    <Col span={16}>
                      :&nbsp;{dataOrder.address}
                      <br /> Provinsi {dataOrder.province_name}, Kota/Kab {dataOrder.city_name}, Kec. {dataOrder.district_name}, Kel. {dataOrder.sub_district_name}, Kode Pos{dataOrder.postcode}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Order" key="2">
              <Row>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Offer</Col>
                    <Col span={16}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataOrder.amh_order_number)}>
                          {dataOrder.amh_order_number}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Order</Col>
                    <Col span={16}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataOrder.order_code)}>
                          {dataOrder.order_code}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Waktu Buat Order</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_create_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Waktu Closing Order</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_closing_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Order Status</Col>
                    <Col span={16}>
                      :&nbsp;<Tag color="#cd201f">{dataOrder.order_status}</Tag>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Sumber Order</Col>
                    <Col span={16}>
                      :&nbsp;{dataOrder.order_source} - {dataOrder.detail_order_source}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Metode Beli</Col>
                    <Col span={16}>
                      :&nbsp;
                      {dataOrder.order_payment_method === "CREDIT" ? <Tag color="#40a9ff">{dataOrder.order_payment_method}</Tag> : <Tag color="#faad14">{dataOrder.order_payment_method}</Tag>}
                    </Col>
                  </Row>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Harga Jual</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_sales_price)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Uang Muka</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.order_down_payment)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Diskon</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.order_discount)}</Col>
                  </Row>
                  {dataOrder.order_payment_method === "CREDIT" && (
                    <>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>PK</Col>
                        <Col span={16}>:&nbsp;{currencyFormat(dataOrder.leasing_repayment)}</Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>PP</Col>
                        <Col span={16}>:&nbsp;{currencyFormat(dataOrder.leasing_subsidies)}</Col>
                      </Row>
                    </>
                  )}
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Dealer</Col>
                    <Col span={16}>:&nbsp;{dataOrder.dealer_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama&nbsp;Dealer</Col>
                    <Col span={16}>:&nbsp;{dataOrder.dealer_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Marketing</Col>
                    <Col span={16}>:&nbsp;{dataOrder.marketing_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama Marketing</Col>
                    <Col span={16}>:&nbsp;{dataOrder.marketing_name}</Col>
                  </Row>
                  <br />
                  {dataOrder.order_payment_method === "CREDIT" && (
                    <>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>Kode Leasing</Col>
                        <Col span={16}>:&nbsp;{dataOrder.leasing_code}</Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>Nama Leasing</Col>
                        <Col span={16}>:&nbsp;{dataOrder.leasing_name}</Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>Tanggal PO</Col>
                        <Col span={16}>:&nbsp;{dataOrder.leasing_po_date}</Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>Tenor</Col>
                        <Col span={16}>:&nbsp;{dataOrder.order_tenor}</Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col span={8}>Angsuran</Col>
                        <Col span={16}>:&nbsp;{currencyFormat(dataOrder.order_installment)}</Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Kendaraan" key="3">
              <Row>
                <Col xl={{ span: 15 }} lg={{ span: 15 }} md={{ span: 15 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Stock</Col>
                    <Col span={16}>:&nbsp;{dataOrder.stock_unit_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode Variant</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_variant_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama Variant</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_variant_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Warna</Col>
                    <Col span={16}>
                      :&nbsp;{dataOrder.vehicle_color_code} - {dataOrder.vehicle_color_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No Mesin</Col>
                    <Col span={16}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataOrder.vehicle_engine_number)}>
                          {dataOrder.vehicle_engine_number}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No Rangka</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_chassis_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Merk</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_brand_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Model</Col>
                    <Col span={16}>
                      :&nbsp;{dataOrder.vehicle_class} - {dataOrder.vehicle_model_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Kode&nbsp;Maindealer</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_maindealer_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Tahun Kendaraan</Col>
                    <Col span={16}>:&nbsp;{dataOrder.vehicle_year}</Col>
                  </Row>
                  <br />
                  {/* <Row gutter={[16, 16]}>
                    <Col span={8}>Harga Beli</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_purchase_price)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Diskon Beli</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_purchase_discount)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>DPP Beli</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_basic_purchase_price)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>PPN Beli</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_purchase_vat)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>HPP Beli</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.vehicle_fixed_purchase_price)}</Col>
                  </Row> */}
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Pengiriman" key="4">
              <Row>
                <Col xl={{ span: 15 }} lg={{ span: 15 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Metode Pengiriman</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_delivery_method}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Tanggal Pengiriman</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_delivery_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No Pengiriman</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_delivery_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Biaya Pengiriman</Col>
                    <Col span={16}>:&nbsp;{currencyFormat(dataOrder.shipment_cost ? dataOrder.shipment_cost : 0)}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={8}>Alamat Pengiriman</Col>
                    <Col span={16}>:&nbsp;{dataOrder.address_shipment}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Dikirim Oleh</Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_delivery_driver_name}</Col>
                  </Row>
                  {/* <Row gutter={[16, 16]}>
                    <Col span={8}>Kendaraan Pengirim </Col>
                    <Col span={16}>:&nbsp;{dataOrder.order_delivery_vehicle_license_plate}</Col>
                  </Row> */}
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Diambil di Dealer</Col>
                    <Col span={16}>:&nbsp;{dataOrder.take_in_dealer?.toString().toUpperCase()}</Col>
                  </Row>
                  <br />
                </Col>
                <Col xl={{ span: 9 }} lg={{ span: 9 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <strong>Detail Pengiriman</strong>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Nama&nbsp;Mediator</Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.mediator_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Telp&nbsp;Mediator</Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.mediator_phone_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Uang diterima Mediator </Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.mediator_credit_amount}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Uang diambil di Konsumen</Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.customer_cash_on_delivery}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Tanggal Est Pengiriman</Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.shipping_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>Tanggal Jatuh Tempo</Col>
                    <Col span={12}>:&nbsp;{dataOrder?.shipping_data?.detail?.shipping_credit_payment_date}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 15 }} lg={{ span: 15 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <strong>Data Handover</strong>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Tanggal Handover</Col>
                    <Col span={16}>:&nbsp;{dataOrder?.handover_delivery_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama Penerima</Col>
                    <Col span={16}>:&nbsp;{dataOrder?.handover_deliver_detail?.receiver_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Telp Penerima</Col>
                    <Col span={16}>:&nbsp;{dataOrder?.handover_deliver_detail?.receiver_phone}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Bukti Terima Unit</Col>
                    <Col span={16}>
                      :&nbsp;
                      {dataOrder?.handover_deliver_detail?.handover_proof_url && (
                        <a href={dataOrder?.handover_deliver_detail?.handover_proof_url} target="_blank" rel="noopener noreferrer">
                          Buka Gambar
                        </a>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Tanda Tangan penerima</Col>
                    <Col span={16}>
                      :&nbsp;
                      {dataOrder?.handover_deliver_detail?.receiver_signature_url && (
                        <a href={dataOrder?.handover_deliver_detail?.receiver_signature_url} target="_blank" rel="noopener noreferrer">
                          Buka Gambar
                        </a>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data BBN" key="5">
              <Row>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Samsat</Col>
                    <Col span={14}>:&nbsp;{dataOrder.samsat_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>BBN Kosong</Col>
                    <Col span={14}>:&nbsp;{dataOrder.transfer_title_null ? dataOrder.transfer_title_null : "FALSE"}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Biro Jasa</Col>
                    <Col span={14}>
                      :&nbsp;{dataOrder.service_bureau_code} - {dataOrder.service_bureau_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>No Invoice</Col>
                    <Col span={14}>
                      :&nbsp;{dataOrder.service_bureau_code} - {dataOrder.service_bureau_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nilai BBN</Col>
                    <Col span={14}>:&nbsp;{currencyFormat(dataOrder.transfer_title_cost_real)}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal Upload Tagihan</Col>
                    <Col span={14}>:&nbsp;{dataOrder.transfer_title_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Status BBN</Col>
                    <Col span={14}>:&nbsp;{dataOrder.transfer_title_status}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Lunas PK & PP</Col>
                    <Col span={14}>
                      :&nbsp;
                      {dataOrder.leasing_flag === "TRUE" ? <Tag color="#40a9ff">{dataOrder.leasing_flag}</Tag> : <Tag color="#faad14">{dataOrder.leasing_flag}</Tag>}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <br />
                    <Col span={24}>
                      <strong>Data Main Dealer</strong>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Penerima</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_receiver_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>ID Order</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_id_order}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal BAST</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_bast_date && dataOrder.daya_bast_date !== "NONE" ? moment(dataOrder.daya_bast_date).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Invoice</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_invoice_stnk}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Waktu Input Invoice</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_input_time && dataOrder.daya_input_time !== "NONE" ? moment(dataOrder.daya_input_time).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal Invoice</Col>
                    <Col span={14}>:&nbsp;{dataOrder.daya_invoice_date && dataOrder.daya_invoice_date !== "NONE" ? moment(dataOrder.daya_invoice_date).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Pajak" key="6">
              <Row>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Status Pajak</Col>
                    <Col span={14}>
                      :&nbsp;<Tag color="#40a9ff">{dataOrder.order_vat_status}</Tag>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal Generate CSV</Col>
                    <Col span={14}>:&nbsp;{dataOrder.generate_csv_date !== "" && dataOrder.generate_csv_date !== "NONE" ? moment(dataOrder.generate_csv_date).format("YYYY-MM-DD HH:mm") : "-"}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal Scan Faktur</Col>
                    <Col span={14}>:&nbsp;{dataOrder.order_vat_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Link Faktur</Col>
                    <Col span={14}>
                      :&nbsp;{" "}
                      {dataOrder.order_vat_number !== "NONE" && (
                        <a href={dataOrder?.order_vat_number} target="_blank" rel="noopener noreferrer">
                          Buka Faktur
                        </a>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <strong>Detail Faktur Pajak</strong>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Pajak</Col>
                    <Col span={14}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataOrder?.tax_data?.tax_invoice_number)}>
                          {dataOrder?.tax_data?.tax_invoice_number}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tanggal Faktur</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.tax_invoice_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nilai Pajak</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.tax_percentage_value}%</Col>
                  </Row>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>DPP Jual</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.dpp_jual > 0 ? currencyFormat(dataOrder?.tax_data?.dpp_jual) : 0}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>PPN Jual</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.ppn_jual > 0 ? currencyFormat(dataOrder?.tax_data?.ppn_jual) : 0}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>DPP Non PPN</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.dpp_jual_non_ppn > 0 ? currencyFormat(dataOrder?.tax_data?.dpp_jual_non_ppn) : 0}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>&nbsp;</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Publisher</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.npwp_publisher_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>NPWP Publisher </Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.npwp_publisher_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Alamat Publisher</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.npwp_publisher_address}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={10}>Receiver</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.receiver_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>NPWP Receiver </Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.receiver_npwp}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Alamat Receiver</Col>
                    <Col span={14}>:&nbsp;{dataOrder?.tax_data?.receiver_address}</Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        )}
      </Modal>
    );
  }
}

export default ModalDetailOrder;
